var BrowseContentHelper, DEAL_CONTENT_CONTAINER, DEAL_SPACE_MSG_CONTENT;

DEAL_CONTENT_CONTAINER = '#deal_content';

DEAL_SPACE_MSG_CONTENT = '#deal_space_message_content';

module.exports = BrowseContentHelper = {
  getDealsMessageSelector: function() {
    return $(DEAL_SPACE_MSG_CONTENT);
  },
  getDealsContentSelector: function() {
    return $(DEAL_CONTENT_CONTAINER);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvaGVscGVycy9jb250ZW50LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvYnJvd3NlL2Zyb250ZW5kL2hlbHBlcnMvY29udGVudC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxzQkFBQSxHQUF5Qjs7QUFDekIsc0JBQUEsR0FBeUI7O0FBRXpCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLG1CQUFBLEdBQ2Y7RUFBQSx1QkFBQSxFQUF5QixTQUFBO1dBQ3ZCLENBQUEsQ0FBRSxzQkFBRjtFQUR1QixDQUF6QjtFQUdBLHVCQUFBLEVBQXlCLFNBQUE7V0FDdkIsQ0FBQSxDQUFFLHNCQUFGO0VBRHVCLENBSHpCIn0=
